import { createInterfaceToken } from '@bmai/shared';
import type { DashboardComposeRequest, DashboardStreamFrame } from '@/shared/assist/DashboardContract';

/** A handle to an open compose stream; closing it cancels the in-flight composition. */
export interface AIExplorerStreamHandle {
    close(): void;
}

/** Callbacks driven as frames arrive over the stream. */
export interface AIExplorerStreamHandlers {
    onFrame(frame: DashboardStreamFrame): void;
    onError(message: string): void;
    onClose(): void;
}

/**
 * The transport that streams a composed dashboard from the BFF. Abstracted as an
 * interface so the layout feature is decoupled from the wire mechanism: the
 * shipped impl is a websocket ({@link ./WebSocketAIExplorerStreamSource}); the LLM
 * brain behind it is a separate, swappable BFF service.
 */
export interface IAIExplorerStreamSource {
    open(request: DashboardComposeRequest, handlers: AIExplorerStreamHandlers): AIExplorerStreamHandle;
}

export const IAIExplorerStreamSourceToken = createInterfaceToken<IAIExplorerStreamSource>('IAIExplorerStreamSource');
